(function() {
    'use strict';

    angular
        .module('liverunApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trainer', {
            parent: 'entity',
            url: '/trainer',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.trainer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trainer/trainers.html',
                    controller: 'TrainerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trainer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('trainer-detail', {
            parent: 'trainer',
            url: '/trainer/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.trainer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/trainer/trainer-detail.html',
                    controller: 'TrainerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trainer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Trainer', function($stateParams, Trainer) {
                    return Trainer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'trainer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('trainer-detail.edit', {
            parent: 'trainer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trainer/trainer-dialog.html',
                    controller: 'TrainerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Trainer', function(Trainer) {
                            return Trainer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('trainer.new', {
            parent: 'trainer',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trainer/trainer-dialog.html',
                    controller: 'TrainerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                nickname: null,
                                aboutMe: null,
                                photoUrl: null,
                                displayOnApp: null,
                                longIntroduction: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('trainer', null, { reload: 'trainer' });
                }, function() {
                    $state.go('trainer');
                });
            }]
        })
        .state('trainer.edit', {
            parent: 'trainer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trainer/trainer-dialog.html',
                    controller: 'TrainerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Trainer', function(Trainer) {
                            return Trainer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('trainer', null, { reload: 'trainer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('trainer.delete', {
            parent: 'trainer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/trainer/trainer-delete-dialog.html',
                    controller: 'TrainerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Trainer', function(Trainer) {
                            return Trainer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('trainer', null, { reload: 'trainer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
